import PillTabList from 'components/Common/PillTabList';
import React, {FC, useState} from 'react';
import {Tabs, TabPanel} from 'react-tabs';

import './styles.scss';

interface PartnerTileProps {
  slug: string;
  logoImg: string;
  logoLink: string;
  ctaLink: string;
}
const PartnerTile: FC<PartnerTileProps> = ({
  slug,
  logoImg,
  logoLink,
  ctaLink,
}: PartnerTileProps) => (
  <div className={`WidgetBetPartners__partner WidgetBetPartners__partner--${slug}`}>
    <a
      className="WidgetBetPartners__logo"
      href={logoLink}
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      <img src={logoImg} alt={slug} />
    </a>
    <a
      className="WidgetBetPartners__link"
      href={ctaLink}
      target="_blank"
      rel="nofollow noopener noreferrer"
    >
      Παιξε νομιμα +21
    </a>
  </div>
);

function WidgetBetPartners(): JSX.Element {
  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <section className="WidgetBetPartners">
      <h2 className="WidgetBetPartners__header">ΣΤΟΙΧΗΜΑΤΙΚΕΣ ΕΤΑΙΡΙΕΣ</h2>
      {/* <Tabs
        className="WidgetBetPartners__tabs"
        selectedIndex={selectedTab}
        onSelect={(index, prevIndex) => index !== prevIndex && setSelectedTab(index)}
      > */}
        {
          // PillTabList({
          //   tabs: ['SPORTS', 'CASINO'],
          // }) /* component used as a function due to issue https://github.com/reactjs/react-tabs/issues/208 */
        }
        {/* <TabPanel> */}
        
          <PartnerTile
            slug="superbet"
            logoImg="https://www.sport24.gr/wp-content/uploads/2026/04/Superbet_Logo_White.png"
            logoLink="https://superbet.gr/"
            ctaLink="https://superbet.gr/"
          />

          <PartnerTile
            slug="stoiximan"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/12/Stoiximan-partnersWHITE_ARTWORK_RGB.png"
            logoLink="https://www.sport24.gr/stoixima-bet/stoiximan-bet/"
            ctaLink="https://wlstoiximan.adsrv.eacdn.com/C.ashx?btag=a_232b_66c_&affid=95&siteid=232&adid=66&c=2003Native1&asclurl=https://www.stoiximan.gr/"
          />

          <PartnerTile
            slug="bet365"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/02/bet365.png"
            logoLink="https://www.bet365.gr/?affiliate=365_00955423&BCTID=1552762549#/HO/"
            ctaLink="https://www.bet365.gr/?affiliate=365_00955423&BCTID=1552762549#/HO/"
          />
          
          <PartnerTile
            slug="betsson"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/09/betsson-100x42-1.png"
            logoLink="https://record.betsson.gr/_t19-CCOcndeERe1XwEh4yWNd7ZgqdRLk/7/"
            ctaLink="https://record.betsson.gr/_t19-CCOcndeERe1XwEh4yWNd7ZgqdRLk/7/"
          />

          {/* <PartnerTile
            slug="interwetten"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/02/interwetten.png"
            logoLink="https://www.interwetten.gr/el/%ce%b1%ce%b8%ce%bb%ce%b7%cf%84%ce%b9%ce%ba%cf%8c-%cf%83%cf%84%ce%bf%ce%af%cf%87%ce%b7%ce%bc%ce%b1?utm_source=coop&utm_medium=8761_Sport24&utm_campaign=SB_Sport24&utm_content=lang_gr&utm_term=logolink"
            ctaLink="https://www.interwetten.gr/el/%ce%b1%ce%b8%ce%bb%ce%b7%cf%84%ce%b9%ce%ba%cf%8c-%cf%83%cf%84%ce%bf%ce%af%cf%87%ce%b7%ce%bc%ce%b1?utm_source=coop&utm_medium=8761_Sport24&utm_campaign=SB_Sport24&utm_content=lang_gr&utm_term=logolink"
          /> */}
          
          <PartnerTile
            slug="bwin"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/02/bwin_100x42.png"
            logoLink="https://www.sport24.gr/stoixima-bet/bwin-bet/"
            ctaLink="https://sports.bwin.gr/el/sports?utm_source=display-24media&utm_campaign=24media_sportsbook&utm_content=c:45166.836&utm_medium=24media&utm_term=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--partner-24media-onside-m21_55-rch-tweb-c:45166&tdpeh=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--partner-24media-onside--rch-tweb-c:45166.836&wm=5143496"
          />

          <PartnerTile
            slug="novibet"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/02/novibet-1.png"
            logoLink="https://www.sport24.gr/stoixima-bet/novibet/"
            ctaLink="https://rt.novibet.partners/o/RCGHyR?lpage=4sgtok&site_id=11636"
          />

          {/* <PartnerTile
            slug="netbet"
            logoImg="https://www.sport24.gr/wp-content/uploads/2025/02/netbet.png"
            logoLink="https://www.sport24.gr/stoixima-bet/netbet/"
            ctaLink="https://banners.netbet.gr/click.php?z=4544&utm_source=sport24.gr&utm_medium=newspromo&utm_campaign=sport24_prmo_banner"
          /> */}
        {/* </TabPanel> */}
        {/* Casino tab panels */}
        {/* <TabPanel> */}
          {/* <PartnerTile
            slug="stoiximan"
            logoImg="https://www.sport24.gr/img/app/8983334/922000/o/0/0/stoiximan_new_white@2x.png"
            logoLink="https://www.sport24.gr/stoiximan-casino"
            ctaLink="https://wlstoiximan.adsrv.eacdn.com/C.ashx?btag=a_232b_66c_&affid=95&siteid=232&adid=66&c=2003Native1&asclurl=https://www.stoiximan.gr/casino/"
          />

          <PartnerTile
            slug="bet365"
            logoImg="https://www.sport24.gr/img/app/8983344/922000/o/0/0/bet365@2x.png"
            logoLink="https://www.bet365.gr/?affiliate=365_00955423&BCTID=1552762549#/HO/"
            ctaLink="https://www.bet365.gr/?affiliate=365_00955423&BCTID=1552762549#/HO/"
          />

          <PartnerTile
            slug="bwin"
            logoImg="https://www.sport24.gr/img/app/9146580/922000/o/0/0/bwin@2x.png"
            logoLink="https://promo.bwin.gr/el/promo/s/p/general/welcome-journeys-stoixima?&utm_source=display-dcm&utm_campaign=24media_sportsbook&utm_content=c:45166.978&utm_medium=dcm&utm_term=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--direct-dcm-onside-m21_55-rch-tweb-c:45166&tdpeh=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--direct-dcm-onside--rch-tweb-c%3A45166.978&wm=5143496"
            ctaLink="https://promo.bwin.gr/el/promo/s/p/general/welcome-journeys-stoixima?&utm_source=display-dcm&utm_campaign=24media_sportsbook&utm_content=c:45166.978&utm_medium=dcm&utm_term=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--direct-dcm-onside-m21_55-rch-tweb-c:45166&tdpeh=5143496-24media_sportsbook-bwin-sprts-gr-15-02-2021-el-brand-display--direct-dcm-onside--rch-tweb-c%3A45166.978&wm=5143496"
          />

          <PartnerTile
            slug="interwetten"
            logoImg="https://www.sport24.gr/img/app/8984220/0/o/0/0/interwetten_logo@2x.png"
            logoLink="https://www.interwetten.gr/el/casino?utm_source=coop&utm_medium=8424_Sport24&utm_campaign=SB_Sport24&utm_content=lang_gr&utm_term=textlink"
            ctaLink="https://www.interwetten.gr/el/casino?utm_source=coop&utm_medium=8424_Sport24&utm_campaign=SB_Sport24&utm_content=lang_gr&utm_term=textlink"
          />

          <PartnerTile
            slug="novibet"
            logoImg="https://www.sport24.gr/img/app/9561258/0/o/0/0/novibet100x42.png"
            logoLink="https://partners.novibet.com/redirect.aspx?pid=11636&bid=2970&redirectURL=https://www.novibet.gr/stoixima?token=register&promocode="
            ctaLink="https://partners.novibet.com/redirect.aspx?pid=11636&bid=2970&redirectURL=https://www.novibet.gr/stoixima?token=register&promocode="
          />

          <PartnerTile
            slug="betshop"
            logoImg="https://www.sport24.gr/img/app/9055977/922000/o/0/0/betshop_new@2x.png"
            logoLink="https://www.betshop.gr/casino?utm_source=sport24.gr&utm_medium=homepage_widget&utm_campaign=cas_betshop_logo_homepage_widget"
            ctaLink="https://www.betshop.gr/casino?utm_source=sport24.gr&utm_medium=homepage_widget&utm_campaign=cas_betshop_logo_homepage_widget"
          /> */}
        {/* </TabPanel>
      </Tabs> */}
      <p className="WidgetBetPartners__footer">
        21+ | ΑΡΜΟΔΙΟΣ ΡΥΘΜΙΣΤΗΣ ΕΕΕΠ | ΚΙΝΔΥΝΟΣ ΕΘΙΣΜΟΥ & ΑΠΩΛΕΙΑΣ ΠΕΡΙΟΥΣΙΑΣ | ΓΡΑΜΜΗ ΒΟΗΘΕΙΑΣ ΚΕΘΕΑ: 210 9237777 | ΠΑΙΞΕ ΥΠΕΥΘΥΝΑ      
      </p>
    </section>
  );
}

export default WidgetBetPartners;
